import {
  calendarWallMoment,
  getCalendarRecordsDateRange,
} from '@/utils/calendarRecordsRange'

/**
 * Ключ кэша маркеров: org + филиал + пост + TZ + месяц (YYYY-MM).
 */
export function buildCalendarRecordMarkersCacheKey({
  orgId,
  departmentId = null,
  postId = null,
  timezone = 'Europe/Moscow',
  monthKey,
}) {
  return [
    String(orgId),
    departmentId != null ? String(departmentId) : 'all',
    postId != null ? String(postId) : 'all',
    timezone || 'Europe/Moscow',
    monthKey,
  ].join('|')
}

/** YYYY-MM для даты в timezone филиала. */
export function getCalendarMonthKey(selectedDate, timezone = 'Europe/Moscow') {
  const tz = timezone || 'Europe/Moscow'
  return calendarWallMoment(selectedDate, tz).format('YYYY-MM')
}

/** Диапазон from/to (YYYY-MM-DD) для месяца YYYY-MM в timezone филиала. */
export function getCalendarMonthDateRange(
  monthKey,
  timezone = 'Europe/Moscow'
) {
  const tz = timezone || 'Europe/Moscow'
  const [year, month] = String(monthKey || '')
    .split('-')
    .map(Number)
  const selectedDate =
    Number.isFinite(year) && Number.isFinite(month)
      ? new Date(year, month - 1, 1)
      : new Date()

  return getCalendarRecordsDateRange({
    selectedDate,
    view: 'month',
    timezone: tz,
  })
}

/**
 * События для vue-cal: по одному на день с маркером (достаточно для точки).
 * @param {Array<{ date: string, count: number }>} markers
 */
export function markersToVueCalEvents(markers) {
  return (markers || [])
    .filter((item) => item?.date && Number(item.count) > 0)
    .map((item) => {
      const start = new Date(`${item.date}T12:00:00`)
      const end = new Date(`${item.date}T12:01:00`)
      return {
        start,
        end,
        title: '',
        class: 'calendar-record-marker',
      }
    })
}
